import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Permanentdelegation } from '../../interface/permanentdelegation/permanentdelegation';
import { Doalog, EmployeeDoaRequest, UsersDoa } from '../../interface/permanentdelegation/userdoa';
import { Log } from '../../interface/permanentdelegation/logs';
import { environment } from '../../../environments/environment';
import { DoaTypes } from '../../interface/permanentdelegation/doatypes';
import { DOATypeAmountDto } from '../../interface/permanentdelegation/doatype-amount-dto';
@Injectable({
    providedIn: 'root'
})
export class PermanentdelegationService {
    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }
    getCategories(employeeNo: string): Observable<Permanentdelegation[]> {
        return this.http.get<Permanentdelegation[]>(`${this.baseUrl}/PermanentDelegation/GetCategory?employeeNo=${employeeNo}`);
    }
    getdirectreport(emailAddress: string): Observable<Permanentdelegation[]> {
        return this.http.get<Permanentdelegation[]>(`${this.baseUrl}/PermanentDelegation/GetDirectReport?emailAddress=${emailAddress}`);
    }
    fetchsingleDelegation(emailAddress: string, catName: string, preferredName: string): Observable<Permanentdelegation[]> {
        return this.http.get<Permanentdelegation[]>(`${this.baseUrl}/PermanentDelegation/GetSingleDelegation?emailAddress=${emailAddress}&catName=${catName}&preferredName=${preferredName}`);
    }
    onAmountClick(typecode: string): Observable<Permanentdelegation[]> {
        return this.http.get<Permanentdelegation[]>(`${this.baseUrl}/PermanentDelegation/GetDoaAMount?typecode=${typecode}`);
    }
    fetchMultipleData(emailAddress: string, catName: string): Observable<Permanentdelegation[]> {
        return this.http.get<Permanentdelegation[]>(`${this.baseUrl}/PermanentDelegation/GetMultipleDelegation?emailAddress=${emailAddress}&catName=${catName}`);
    }
    createDOA(employeesDoa: UsersDoa[]): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/PermanentDelegation/CreateDOA`, employeesDoa);
    }
    getLoggedUserInfo(email: string): Observable<Permanentdelegation[]> {
        return this.http.get<Permanentdelegation[]>(`${this.baseUrl}/PermanentDelegation/GetInfo?emailaddress=${email}`);
    }
    getDoaType(): Observable<DoaTypes[]> {
        return this.http.get<DoaTypes[]>(`${this.baseUrl}/PermanentDelegation/GetDoaType`);
    }
    getDoaTypeAmount(): Observable<DOATypeAmountDto[]> {
        return this.http.get<DOATypeAmountDto[]>(`${this.baseUrl}/PermanentDelegation/GetDoaTypeAmount`);
    }
    addDoaType(doaType: DOATypeAmountDto): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(`${this.baseUrl}/PermanentDelegation/SaveDoaTypeAmount`, doaType, { headers });
    }
    deleteDoaType(newId: number): Observable<DOATypeAmountDto[]> {
        return this.http.delete<DOATypeAmountDto[]>(`${this.baseUrl}/PermanentDelegation/DeleteDoaTypeAmount?newId=${newId}`);
    }

    getAmountByTypeCode(typeCode: string): Observable<DOATypeAmountDto[]> {
        return this.http.get<DOATypeAmountDto[]>(`${this.baseUrl}/PermanentDelegation/GetAmountByTypeCode?typeCode=${typeCode}`);
    }
    submitEmployeeDoa(request: EmployeeDoaRequest): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/PermanentDelegation/log`, request);
    }
    getDOALogs(loggedUserEmail: string, startDate: string | null, endDate: string | null): Observable<Doalog[]> {
        let url = `${this.baseUrl}/PermanentDelegation/GetLogs?lastModifiedBy=${loggedUserEmail}`;
        if (startDate && endDate) {
        url += `&startDate=${startDate}&endDate=${endDate}`;
        }
        return this.http.get<Doalog[]>(url);
    }
  
    public getDOAlogsWorksheet(obj: any[]): Observable<Blob> {
      return this.http.post(`${this.baseUrl}/PermanentDelegation/DoalogsWorksheet`, obj, { responseType: 'blob' });
    }
  

      
      

}
